import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Input,
} from "reactstrap";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";
import { TreeSelect } from "primereact/treeselect";
import { Checkbox } from "primereact/checkbox";
import { MultiSelect } from "primereact/multiselect";
import { Editor } from "primereact/editor";
import { Toast } from 'primereact/toast';
import { Button as PrimeButton } from "primereact/button";
import { Button } from "primereact/button";
import { Chips } from "primereact/chips";
import { Link, useNavigate } from "react-router-dom";
import { FileUpload } from 'primereact/fileupload';
import WorkType1 from "../common-for-all/WorkTypeOne";
import WorkType3 from "../common-for-all/WorkTypeThree";
import EstimateTable from "./EstimateTable";
import EstimateDelay from "./EstimateDelay";
import axios from "axios";
import { getCookie } from "../../helpers/cookie";
import { getCompanies, getEntityNotes, createEntityNote, updateEntityNote, deleteEntityNote, getLookupsByName } from "../../helpers/backend-helper";
import { set } from "lodash";
import { InputTextarea } from "primereact/inputtextarea";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { NOTIFICATION_API_STATUS_FALSE, NOTIFICATION_API_STATUS_TRUE } from "../../store/calendar/actionTypes";
    const ProjectEditForm = () => {
    // Project   Information States
    const dispatch = useDispatch();
    const {  register: StageRegister,trigger: StageTrigger,formState: { errors: StageErrors },reset: resetStageForm,setValue: setStageValue,handleSubmit: stageSubmit} = useForm();
    const token = getCookie('access_token');
    const [projectCode, setProjectCode] = useState("");
    const [projectName, setProjectName] = useState("");
    const [selectedModule, setSelectedModule] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [compamyitem, setcompamyitem] = useState([])
    const fileUploadRef = useRef(null)
    const [uploadedFiles, setUploadedFiles] = useState(null);
    const [selectedDeliveryCompany, setSelectedDeliveryCompany] = useState(null);
    const fileRef = useRef(null);
    const [loader, setLoader] = useState(true);
    const getCompanydata = async () => {
        try {
          const response = await getCompanies();
          // normalize possible response shapes
          let items = []
          if (Array.isArray(response)) items = response
          else if (response && Array.isArray(response.results)) items = response.results
          else if (response && Array.isArray(response.data)) items = response.data
    
          // map companies to a consistent shape used by the UI
          const mapped = items.map(c => ({
            id: c.id || c.pk || c.company_id,
            name: c.name || c.company_name || c.title || "",
            code: c.code || c.company_code || null,
            label: c.name || c.company_name || c.title || "",
            value: c.id || c.pk || c.company_id || c.name || null,
            __raw: c,
          }))
    
          setcompamyitem(mapped);
        } catch (error) {
          console.error("Error fetching companies:", error);
        }
      }
    useEffect(() => {
        getCompanydata();
    }, []);
    const [projectManager, setProjectManager] = useState("");
    const [selectedProjectStatus, setSelectedProjectStatus] = useState(null);
    const params = new URLSearchParams(window.location.search);
    const Editid = params.get("id");
    // Project Timeline States
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [extendedEndDate, setExtendedEndDate] = useState(null);
    console.log(extendedEndDate,'extendedEndDate');
    
    const [reasonForDelay, setReasonForDelay] = useState("");
    // System Fields States
    const [createdBy, setCreatedBy] = useState("");
    const [createdDate, setCreatedDate] = useState(new Date());
    const [lastModifiedBy, setLastModifiedBy] = useState("");
    const [lastModifiedDate, setLastModifiedDate] = useState(new Date());
    const [description, setdescription] = useState('')  
    // Notes State
    const [notes, setNotes] = useState("");
    const [isEditorVisible, setIsEditorVisible] = useState(false);
    const [editorContent, setEditorContent] = useState("");
    const [projectNotes, setProjectNotes] = useState([]);
    const [editingNoteIndex, setEditingNoteIndex] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState({ visible: false, noteIndex: null });
    const [notesLoading, setNotesLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);

    // Document states
    const [displayDialog, setDisplayDialog] = useState(false);
    const [displayDialog1, setDisplayDialog1] = useState(false);
    const [documents, setDocuments] = useState();
    const getDocuments =async (id)=>
    {
      try
      {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/documents/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200) {
          console.log(response, 'responseiojiodjio');
          const apiData = response.data.data;
  setDocuments(apiData);
        }
      }catch(err) 
      {
        console.log(err);
        
      }
    }
    const [documentTypes, setdocumentTypes] = useState([]);
    const getDoctType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status===200) {
                    const options = response.data.results.results.map((category) => ({
            name: category.value
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase()),
            code: category.id,
            }));
            setdocumentTypes(options);
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(() => {
        if (Editid) {
            getDocuments(Editid);
            // getDoctType();
        }
    }, [Editid]);

    const [selectedDocument, setSelectedDocument] = useState(null);
    const [subject, setSubject] = useState('');
    const [file, setFile] = useState(null);
    // Phase states
    const [phaseDialog, setPhaseDialog] = useState(false);
    const [currentPhase, setCurrentPhase] = useState({
        phase: '',
        startDate: null,
        endDate: null,
        deliverables: [],
        responsible: ''
    });
    const [responsibleOptions, setResponsibleOptions] = useState([]);

    // Private checkbox and MultiSelect states
    const [popchecked2, setPopchecked2] = useState(false);
    const [privateDrop, setPrivateDrop] = useState([]);

    const handlePopupCheckbox2 = e => {
        setPopchecked2(e.checked);
    };

    const [PrivetDropdownValues, setPrivetDropdownValues] = useState(null)
 const getPrivateOptions = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.data) {
                let results = response.data.data;
                console.log(results, 'results');
                const options = results.map((category) => ({
                    name: category.name
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase()),
                    code: category.id,
                    email: category.email,
                }));
                setPrivetDropdownValues(options);
            }
        } catch (error) {
            // Fallback in case of error
            console.error('Error fetching private users:', error);
        }
    };
    // useEffect(() => {
    //     getPrivateOptions()
    // }, []);

    const handleUpload = (e) => {
        setFile(e.files[0]);
    };

    const customBase64Uploader2 = (event) => {
        setFile(event.files[0]);
    };
    const handleAddDocument = async () => {
        try {
            const formData = new FormData();

            // Assuming `title` is a text input value (not the selectedDocument id)
            formData.append('type', selectedDocument || '');

            // If description is coming from state (like subject)
            formData.append('description', subject || '');

            // File handling - single file
            if (uploadedFiles instanceof File) {
                formData.append('uploaded_files', uploadedFiles);
            }
            else if (Array.isArray(uploadedFiles)) {
                uploadedFiles.forEach((file, idx) => {
                    formData.append('uploaded_files', file); // if backend expects multiple "file" entries
                    // OR use: formData.append(`file_${idx}`, file);
                });
            }

            const response = await axios.post(
                `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/documents/`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );


            if (response.status === 201) {
                console.log('Document added successfully:', response.data)
                setDisplayDialog(false);
                setSelectedDocument(null);
                setSubject('');
                setFile(null);
                getDocuments(); 
            }
        } catch (error) {
            console.error('Error adding document:', error);
        }
    };


    const openAddDocumentDialog = () => {
        setDisplayDialog(true);
    };

    const closeAddDocumentDialog = () => {
        setDisplayDialog(false);
    };

    // Phase dialog handlers
    const openAddPhaseDialog = () => {
        setCurrentPhase({
            phase: '',
            startDate: null,
            endDate: null,
            deliverables: [],
            responsible: ''
        });
        setPhaseDialog(true);
    };

    const closeAddPhaseDialog = () => {
        setPhaseDialog(false);
    };

    // Fetch responsible options from lookup
    const fetchResponsibleOptions = async () => {
        try {
            const lookupData = await getLookupsByName('project_responsible');
            
            // Handle different response structures
            let responsibleData = [];
            if (lookupData) {
                if (Array.isArray(lookupData)) {
                    responsibleData = lookupData;
                } else if (lookupData.results && Array.isArray(lookupData.results)) {
                    responsibleData = lookupData.results;
                } else if (lookupData.results && lookupData.results.results && Array.isArray(lookupData.results.results)) {
                    responsibleData = lookupData.results.results;
                } else if (lookupData.data && Array.isArray(lookupData.data)) {
                    responsibleData = lookupData.data;
                }
            }
            
            
            if (responsibleData.length > 0) {
                const options = responsibleData.map(item => {
                    return {
                        label: item.display_value || item.display_name || item.value || item.name || item.text,
                        value: item.id || item.pk || item.value
                    };
                });
                setResponsibleOptions(options);
            } else {
                console.log('No lookup data found, using fallback options');
                // Fallback to default options if lookup fails
                const defaultOptions = [
                    'Project Manager',
                    'Business Analyst',
                    'UI/UX Designer',
                    'Software Developer',
                    'DevOps Engineer',
                    'QA Engineer',
                    'Product Owner',
                    'Scrum Master',
                    'Technical Lead',
                    'System Architect'
                ];
                setResponsibleOptions(defaultOptions.map((opt, index) => ({ 
                    label: opt, 
                    value: `fallback_${index}` // Use fallback IDs for default options
                })));
            }
        } catch (error) {
            console.error('Error fetching responsible options:', error);
            // Fallback to default options
            const defaultOptions = [
                'Project Manager',
                'Business Analyst',
                'UI/UX Designer',
                'Software Developer',
                'DevOps Engineer',
                'QA Engineer',
                'Product Owner',
                'Scrum Master',
                'Technical Lead',
                'System Architect'
            ];
            setResponsibleOptions(defaultOptions.map((opt, index) => ({ 
                label: opt, 
                value: `fallback_${index}` // Use fallback IDs for default options
            })));
        }
    };

    const groupedDocuments = [
        {
            label: 'Project Documentation',
            items: [
                { label: 'Project Requirements Document', value: 'Project Requirements Document' },
                { label: 'Technical Specifications', value: 'Technical Specifications' },
                { label: 'Design Documents', value: 'Design Documents' },
                { label: 'User Stories', value: 'User Stories' },
                { label: 'Test Plans', value: 'Test Plans' }
            ]
        },
        {
            label: 'Legal and Compliance',
            items: [
                { label: 'Project Charter', value: 'Project Charter' },
                { label: 'Stakeholder Agreement', value: 'Stakeholder Agreement' },
                { label: 'Risk Assessment', value: 'Risk Assessment' },
                { label: 'Compliance Documentation', value: 'Compliance Documentation' }
            ]
        },
        {
            label: 'Development Assets',
            items: [
                { label: 'Source Code Documentation', value: 'Source Code Documentation' },
                { label: 'API Documentation', value: 'API Documentation' },
                { label: 'Database Schema', value: 'Database Schema' },
                { label: 'Deployment Guide', value: 'Deployment Guide' }
            ]
        }
    ];

    const groupedItemTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <i className="pi pi-file mr-2"></i>
                <div>{option.label}</div>
            </div>
        );
    };

    // WorkType configurations with state management
    const [moduleWorkTypes, setModuleWorkTypes] = useState([]);

    const [companyWorkTypes, setCompanyWorkTypes] = useState([]);

    const [statusWorkTypes, setStatusWorkTypes] = useState([]);

    // Callback handlers for work type changes
    const handleModuleWorkTypesChange = (updatedWorkTypes) => {
        setModuleWorkTypes(updatedWorkTypes);
    };

    const handleCompanyWorkTypesChange = (updatedWorkTypes) => {
        setCompanyWorkTypes(updatedWorkTypes);
    };

    const handleStatusWorkTypesChange = (updatedWorkTypes) => {
        setStatusWorkTypes(updatedWorkTypes);
    };

    const handleModuleSelectionChange = (selectedWorkType) => {
        setSelectedModule(selectedWorkType);
    };

    const handleCompanySelectionChange = (selectedWorkType) => {
        setSelectedCompany(selectedWorkType);
    };

    const handleStatusSelectionChange = (selectedWorkType) => {
        setSelectedProjectStatus(selectedWorkType);
    };

    // Dynamic dropdown configurations
    const moduleDropdownWorkTypes = [
        ...moduleWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Module', id: 'create-new-work-type' },
        { name: 'Edit Module', id: 'edit-selected-work-type' }
    ];

    const companyDropdownWorkTypes = [
        ...companyWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Company', id: 'create-new-work-type' },
        { name: 'Edit Company', id: 'edit-selected-work-type' }
    ];

    const statusDropdownWorkTypes = [
        ...statusWorkTypes,
        { id: 'divider', disabled: true },
        { name: 'Add Status', id: 'create-new-work-type' },
        { name: 'Edit Status', id: 'edit-selected-work-type' }
    ];

    // Dropdown options
    const moduleOptions = [
        { label: 'User Management Module', value: 'user-mgmt' },
        { label: 'Authentication Module', value: 'auth-module' },
        { label: 'Payment Gateway', value: 'payment' },
        { label: 'Reporting Module', value: 'reporting' },
        { label: 'Admin Dashboard', value: 'admin-dash' }
    ];

    const projectStatusOptions = [
        { label: 'Planning', value: 'planning' },
        { label: 'In Progress', value: 'in-progress' },
        { label: 'Testing', value: 'testing' },
        { label: 'On Hold', value: 'on-hold' },
        { label: 'Completed', value: 'completed' },
        { label: 'Cancelled', value: 'cancelled' }
    ];

    // Editor configuration
    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    };

    const header = renderHeader();

    const [content, setContent] = useState("");

    const maxWords = 500;

    const calculateWordCount = (text) => {
        const words = text
            .trim()
            .replace(/<[^>]*>/g, "")
            .split(/\s+/);
        return words.filter((word) => word).length;
    };

    const currentWordCount = calculateWordCount(content);

    const handleEditorChange = (e) => {
        const text = e.htmlValue || "";
        if (calculateWordCount(text) <= maxWords) {
            setContent(text);
        }
    };

    // Navigation
    const navigate = useNavigate();

    // Submit handler - PATCH project
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaveLoading(true);
        setLoader(true);
       function formatDate(date) {
  if (!date) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}


        // const payload = {
        //     code: projectCode,
        //     name: projectName,
        //     project_manager_company: selectedCompany || "",
        //     project_manager: selectedProjectManager || null,
        //     delivery_manager_company: selectedDeliveryCompany || "",
        //     delivery_manager: selectedDeliveryManager || "",
        //     company: selectedCompany && (selectedCompany.id || selectedCompany.value || selectedCompany),
        //     module_submodule_info: selectedModule && (selectedModule.value || selectedModule.id || selectedModule),
        //     // project_status: selectedProjectStatus && (selectedProjectStatus.value || selectedProjectStatus.id || selectedProjectStatus),
        //     start_date: formatDate(startDate),
        //     end_date: formatDate(endDate),
        //     extended_end_date: formatDate(extendedEndDate),
        //     delay_reason: reasonForDelay || null,
        //     overview: content || null,
        //     is_private: popchecked2,
        //     private_users: popchecked2 ? privateDrop : [],
        //     attachment_file: uploadedFiles || null,
        // };
const formData = new FormData();

formData.append("code", projectCode);
formData.append("name", projectName);
formData.append("project_manager_company", selectedCompany || "");
formData.append("project_manager", selectedProjectManager || null);
formData.append("delivery_manager_company", selectedDeliveryCompany || "");
formData.append("delivery_manager", selectedDeliveryManager || "");
formData.append("company",selectedCompany && (selectedCompany.id || selectedCompany.value || selectedCompany));
formData.append("start_date", formatDate(startDate));
formData.append("end_date", formatDate(endDate));
if (extendedEndDate) {formData.append("extended_end_date",formatDate(extendedEndDate));
}


formData.append("reason_for_delay", reasonForDelay || "");
formData.append("description", content || "");
// pass only when user uploads new file
if (uploadedFiles instanceof File) {
  formData.append("attachment_file", uploadedFiles);
}


        try {
            const res = await axios.patch(
                `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/`,
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.status === 200 || res.status === 204) {
                toast.current?.show({ severity: 'success', summary: 'Saved', detail: 'Project updated successfully' });
                navigate('/allactive-project');
                dispatch({ type: NOTIFICATION_API_STATUS_TRUE })
                setTimeout(() => {
                    dispatch({ type: NOTIFICATION_API_STATUS_FALSE })
                }, 2000)
            } else {
                toast.current?.show({ severity: 'warn', summary: 'Not saved', detail: 'Unexpected status ' + res.status });
            }
        } catch (err) {
            console.error('Failed to save project', err.response.data.message);
            let errorMessage = err.response.data.message || err.message || 'Failed to update project';
            toast.current?.show({
          severity: "error",
          summary:"Error",
          detail: errorMessage,
        });
        } finally {
            setSaveLoading(false);
            setLoader(false);
        }
    }

    // Toast messages
    const toast = useRef(null);

    const showMessage = () => {
        toast.current.show({ severity: 'info', summary: 'Project Saved Successfully' });
    };

    const showCancel = () => {
        toast.current.show({ severity: 'error', summary: 'Cancelled', life: 3000 });
    };

    const handleAddNotes = () => {
        setIsEditorVisible(true);
        setEditorContent("");
        setEditingNoteIndex(null);
    };

    // Fetch project notes from backend
    const fetchProjectNotes = async () => {
        if (Editid) {
            setNotesLoading(true);
            try {
                const response = await getEntityNotes('projects', Editid);
                console.log("Fetch notes response:", response); // Debug log
                if (response.status_code === 200 && response.data) {
                    const formattedNotes = response.data.map(note => ({
                        id: note.id,
                        candidateName: note.created_by_name || note.created_by ||" ",
                        timestamp: note.created_at ? new Date(note.created_at).toLocaleString() : new Date().toLocaleString(),
                        content: note.content,
                        title: note.title,
                        is_important: note.is_important
                    }));
                    setProjectNotes(formattedNotes);
                } else {
                    console.warn("Unexpected response format:", response);
                    setProjectNotes([]);
                }
            } catch (error) {
                console.error("Error fetching project notes:", error);
                setProjectNotes([]); // Set empty array on error
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch project notes'
                });
            } finally {
                setNotesLoading(false);
            }
        }
    };

    const handleSaveNotes = async () => {
        if (!editorContent.trim()) {
            toast.current?.show({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please enter some content for the note.'
            });
            return;
        }

        if (!Editid) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Project ID is required to save notes.'
            });
            return;
        }

        setSaveLoading(true);
        try {
            const noteData = {
                title: "Project Note",
                content: editorContent,
                is_important: true
            };

            let response;

            if (editingNoteIndex !== null) {
                // Update existing note
                const noteToUpdate = projectNotes[editingNoteIndex];
                response = await updateEntityNote('projects', Editid, noteToUpdate.id, noteData);
                
                if (response.status_code === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Note Updated',
                        detail: 'Note has been updated successfully!'
                    });
                    fetchProjectNotes(); // Refresh notes list
                }
            } else {
                // Create new note
                response = await createEntityNote('projects', Editid, noteData);
                
                if (response.status_code === 201) {
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Note Added',
                        detail: 'Note has been added successfully!'
                    });
                    fetchProjectNotes(); // Refresh notes list
                }
            }

            setIsEditorVisible(false);
            setEditorContent("");
            setEditingNoteIndex(null);

        } catch (error) {
            console.error("Error saving note:", error);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to save note. Please try again.'
            });
        } finally {
            setSaveLoading(false);
        }
    };

    const handleCancelNotes = () => {
        setIsEditorVisible(false);
        setEditorContent("");
        setEditingNoteIndex(null);
    };

    const handleEditNote = (index) => {
        setEditingNoteIndex(index);
        setEditorContent(projectNotes[index].content);
        setIsEditorVisible(true);
    };

    const confirmDeleteNote = (index) => {
        setConfirmDialog({ visible: true, noteIndex: index });
    };

    const handleDeleteNote = async (index) => {
        if (!Editid) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Project ID is required to delete notes.'
            });
            return;
        }

        try {
            const noteToDelete = projectNotes[index];
            if (noteToDelete.id) {
                const response = await deleteEntityNote('projects', Editid, noteToDelete.id);
                
                if (response.status_code === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: 'Note Deleted',
                        detail: 'Note has been deleted successfully!'
                    });
                    fetchProjectNotes(); // Refresh notes list
                }
            } else {
                // If note doesn't have an ID (local only), remove from local state
                const updatedNotes = projectNotes.filter((_, i) => i !== index);
                setProjectNotes(updatedNotes);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Note Deleted',
                    detail: 'Note has been deleted successfully!'
                });
            }
        } catch (error) {
            console.error("Error deleting note:", error);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to delete note. Please try again.'
            });
        } finally {
            setConfirmDialog({ visible: false, noteIndex: null });
        }
    };
    
    const getProjectModules = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=project_module`, 
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            
            // Transform the API response to match WorkType1 format
            const transformedModules = response.data.results.results.map(module => ({
                name: module.value,
                color: '#000000',
                id: module.id.toString(),
                statuses: ['Pending', 'Processing', 'Completed'],
                __original: module
            }));
            
            setModuleWorkTypes(transformedModules);
        } catch (err) {
            console.log("Error fetching project modules:", err);
        }
    };

    const getCompaniesData = async () => {
        try {
            const response = await getCompanies();
            console.debug("getCompaniesData raw response:", response);
            
            // Normalize possible response shapes
            let items = []
            if (Array.isArray(response)) items = response
            else if (response && Array.isArray(response.results)) items = response.results
            else if (response && Array.isArray(response.data)) items = response.data

            // Transform companies to match WorkType1 format
            const transformedCompanies = items.map(company => ({
                name: company.name || company.company_name || company.title || "",
                color: '#000000',
                id: (company.id || company.pk || company.company_id || company.name).toString(),
                statuses: ['Pending', 'Processing', 'Completed'],
                __original: company
            }));
            
            setCompanyWorkTypes(transformedCompanies);
        } catch (err) {
            console.log("Error fetching companies:", err);
        }
    };

    const getProjectStatus = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=project_status`, 
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            const transformedStatus = response.data.results.results.map(status => ({
                name: status.value,
                color: '#000000',
                id: status.id.toString(),
                statuses: ['Pending', 'Processing', 'Completed'],
                __original: status
            }));
            
            setStatusWorkTypes(transformedStatus);
        } catch (err) {
            console.log("Error fetching project status:", err);
        }
    };
    const getProjectManager = async (id) => {
        try {
            // setLoader(true);
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/employees/?company=${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 200) {
                const apiData = response.data.results;
                setProjectManagerOptions(
                    apiData.map((item) => ({
                        name: item.full_name,
                        id: item.id,
                        email: item.email,
                    }))
                );
            setLoader(false);
            }
        } catch (err) {
            console.error("Error fetching team data:", err);
            setLoader(false);

        }
    };
    const getDeliveryManager = async (id) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/employees/?company=${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 200) {
                const apiData = response.data.results;
                setDeliveryManagerOptions(
                    apiData.map((item) => ({
                        name: item.full_name,
                        id: item.id,
                        email: item.email,
                    }))
                );
            }
        } catch (err) {
            console.error("Error fetching team data:", err);
        }
    };
    const getData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                const projectData = response.data;
                setStartDate(projectData.start_date ? new Date(projectData.start_date) : null);
                setEndDate(projectData.end_date ? new Date(projectData.end_date) : null);
                setExtendedEndDate(projectData.extended_end_date ? new Date(projectData.extended_end_date) : null);
                setReasonForDelay(projectData.reason_for_delay || "");
                setProjectCode(projectData.code || "");
                setProjectName(projectData.name || "");
                setProjectManager(projectData.project_manager_name || "");
                getProjectManager(projectData.company)
                setSelectedCompany(projectData.company)
                setSelectedDeliveryCompany(projectData.delivery_manager_company || "");
                getDeliveryManager(projectData.delivery_manager_company)
                setSelectedDeliveryManager(projectData.delivery_manager || null);
                setUploadedFiles(projectData.attachment_file || null); 
                setSelectedModule(projectData.module_submodule_info );
                setSelectedProjectStatus(String(projectData?.project_status));
                setSelectedProjectManager(projectData?.project_manager);
                setContent(projectData.description || "");
                getProjectManager(projectData.company)
                setCreatedBy(projectData.created_by_name || "");
                setCreatedDate(projectData.created_at ? new Date(projectData.created_at) : null);
                setLastModifiedBy(projectData.updated_by_name || "");
                setLastModifiedDate(projectData.updated_at ? new Date(projectData.updated_at) : null);
                setPrivateDrop(projectData.private_user_ids || []);
                setPopchecked2(projectData.is_private || false);
            }
        } catch (error) {
            console.error("Error fetching project data:", error);
        }
    };
      const [selectedProjectManager, setSelectedProjectManager] = useState(null)
      const [ProjectManagerOptions, setProjectManagerOptions] = useState([])
      const [selectedDeliveryManager, setSelectedDeliveryManager] = useState(null)
      const [DeliveryManagerOptions, setDeliveryManagerOptions] = useState([])
    useEffect(() => {
        // getProjectModules(); // Load modules on component mount
        getCompaniesData(); // Load companies on component mount
        // getProjectStatus(); // Load project status on component mount
        // fetchResponsibleOptions(); // Load responsible options from lookup
        if (Editid) {
            getData();
            fetchProjectNotes(); // Fetch project notes when editing existing project
        }
    }, [Editid])
    const [showStagepopup, setshowStagepopup] = useState(false);
    const [selectedresponsiblePerson, setSelectedresponsiblePerson] = useState(null)
    const [selectedresponsiblePersonCompany, setSelectedresponsiblePersonCompany] = useState(null)
    const [selectedGroup, setSelectedGroup] = useState(null)
    const [groupOptions, setGroupOptions] = useState([])
    console.log(groupOptions, 'groupOptions');
    
    const [teamData, setTeamData] = useState([])
    const handleCancelStagePopup = () => {
         setshowStagepopup(false);
         setSelectedresponsiblePersonCompany(null); 
         setSelectedresponsiblePerson(null);
          setSelectedGroup(null);
         resetStageForm();
    }
    const [teamLoading, setTeamLoading] = useState(false);
    const getTeam = async (id) => {
        try {
            setTeamLoading(true);
            const response = await axios.get(
              `${process.env.REACT_APP_Company_Contact}/company/employees/?company=${id}`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
      
            if (response.status === 200) {
              const mappedData = response.data.results.map((emp) => ({
                id: emp.id,
                name: emp.full_name,
                description: emp.designation_name || "-",
                role: emp.project_membership?.role || "Not Assigned",
                email: emp.primary_email,
                phone: emp.office_phone,
                is_in_project_team: emp.project_membership?.is_in_project_team || false,
              }));
              const sortedData = mappedData.sort(
                (a, b) => b.is_in_project_team - a.is_in_project_team
              );
              
              setTeamData(sortedData);
              setTeamLoading(false);
            }
          } catch (err) {
            console.error("Error fetching team data:", err);
            setTeamLoading(false);
          }
        };
      
        const getGroup = async () => {
            try {
              const response = await axios.get(
                `${process.env.REACT_APP_Company_Contact}/company/${Editid}/groups/`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
        
              if (response.status === 200) {
                setGroupOptions(response.data?.results || response.data?.data || response.data||[]);
              }
            } catch (err) {
              console.log(err);``
            }
          };

useEffect(() => {
    getGroup();
}, [Editid]);
    const [SelectedEditdrop, setSelectedEditdrop] = useState(null);
    const [lastSelectedModuleId, setLastSelectedModuleId] = useState(null);
    const [lookupModalVisible, setLookupModalVisible] = useState(false)
    const [lookupModalContext, setLookupModalContext] = useState('')
    const [lookupFormValue, setLookupFormValue] = useState('')
    const [editingLookup, setEditingLookup] = useState(false)
    const [lastSelectedLookupId, setLastSelectedLookupId] = useState(null)
    const [lastSelectedDocumentId, setLastSelectedDocumentId] = useState(null)
     useEffect(() => {
        if (selectedModule && selectedModule !== 'add' && selectedModule !== 'edit') {
          setLastSelectedModuleId(selectedModule);
        }
    
        if (selectedModule === 'add') {
          setLookupModalVisible(true);
          setLookupFormValue('');
          setEditingLookup(false);
          setLookupModalContext('project_module');
          setSelectedModule(null);
          setSelectedEditdrop(null);
        } else if (selectedModule === 'edit') {
          if (lastSelectedModuleId) {
            setEditingLookup(true);
            setSelectedEditdrop(lastSelectedModuleId);
            const current = moduleWorkTypes?.find(opt => opt.id === lastSelectedModuleId);
            setLookupFormValue(current?.value || current?.name || '');
            setLookupModalVisible(true);
            setLookupModalContext('project_module');
            setSelectedModule(lastSelectedModuleId);
            setLastSelectedLookupId(lastSelectedModuleId);
            setSelectedEditdrop(lastSelectedModuleId);
          } else {
            console.warn('No module selected to edit!');
          }
        }
      }, [selectedModule, lastSelectedModuleId]);
       useEffect(() => {
        if (selectedProjectStatus && selectedProjectStatus !== 'add' && selectedProjectStatus !== 'edit') {
          setLastSelectedModuleId(selectedProjectStatus);
        }  
        if (selectedProjectStatus === 'add') {
          setLookupModalVisible(true);
          setLookupFormValue('');
          setEditingLookup(false);
          setLookupModalContext('project_status');
          setSelectedProjectStatus(null);
        } else if (selectedProjectStatus === 'edit') {
          if (lastSelectedModuleId) {
            setEditingLookup(true);
            setSelectedEditdrop(lastSelectedModuleId);
            const current = statusWorkTypes?.find(opt => opt.id === lastSelectedModuleId);
            setLookupFormValue(current?.value || current?.name || '');
            setLookupModalVisible(true);
            setLookupModalContext('project_status');
            setSelectedProjectStatus(lastSelectedModuleId);
            setLastSelectedLookupId(lastSelectedModuleId);
          } else { 
            console.warn('No module selected to edit!');
          }
        }
      }, [selectedProjectStatus, lastSelectedModuleId]);
    useEffect(() => {
        if (selectedDocument && selectedDocument !== 'add' && selectedDocument !== 'edit') {
            setLastSelectedDocumentId(selectedDocument);
        }

        if (selectedDocument === 'add') {
            setLookupModalVisible(true);
            setLookupFormValue('');
            setEditingLookup(false);
            setLookupModalContext('contact_document_type'); 
            setSelectedDocument(null);
        } else if (selectedDocument === 'edit') {
            if (lastSelectedDocumentId) {
                setEditingLookup(true);
                setSelectedEditdrop(lastSelectedDocumentId);
                const current = documentTypes?.find(opt => opt.code === lastSelectedDocumentId);
                setLookupFormValue(current?.name || '');
                setLookupModalVisible(true);
                setLookupModalContext('contact_document_type'); 
                setSelectedDocument(lastSelectedDocumentId);
                setLastSelectedLookupId(lastSelectedDocumentId);
            } else {
                console.warn('No document selected to edit!');
            }
        }
    }, [selectedDocument, lastSelectedDocumentId, documentTypes]);

      const [selecteddropoptions, setselecteddropoptions] = useState(null)
      useEffect(() => {
          if (lookupModalContext === 'project_module') {
              setselecteddropoptions((moduleWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.value || d.name || d.label || String(d.id), code: d.code, raw: d })));
          } else if (lookupModalContext === 'project_status') {
              setselecteddropoptions((statusWorkTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.value || d.name || d.label || String(d.id), code: d.code, raw: d })));
          } else if (lookupModalContext === 'contact_document_type') {
              setselecteddropoptions((documentTypes || []).map(d => ({ id: d.id ?? d.code ?? d.value, name: d.value || d.name || d.label || String(d.id), code: d.code, raw: d })));
          } else {
              setselecteddropoptions([])
          }
      }, [lookupModalContext, moduleWorkTypes, statusWorkTypes, documentTypes])
       const handleLookupSave = async () => {
          try {
            if (lookupFormValue?.trim() === '') {
              toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty' })
              return
              
            }
            const token = getCookie('access_token')
            const payload = { value: lookupFormValue,name: lookupModalContext , description: description }
            if (editingLookup && lastSelectedLookupId) {
              await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedLookupId}/`, payload, { headers: { Authorization: `Bearer ${token}` } })
            } else {
              await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, { name: lookupModalContext, ...payload }, { headers: { Authorization: `Bearer ${token}` } })
            }
            // Refresh relevant lists depending on context
            if (lookupModalContext === 'project_module') {
              await getProjectModules()
            } else if (lookupModalContext === 'project_status') {
              await getProjectStatus()
            } else if (lookupModalContext === 'contact_document_type') {
              await getDoctType()
            }
            setLookupModalVisible(false)
            setdescription('')
            setSuccessAlert(true)
          } catch (err) {
            console.error('Error saving lookup', err)
          }
        }
    const [FileNames, setFileNames] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const handleEdit = (doc) => {
        openAddDocumentDialog();
        setSelectedDocId(doc.id);
        setIsEdit(true);
        setSubject(doc.description);
        setSelectedDocument(doc.type || null);
        const LastFiles = Array.isArray(doc.files)
            ? doc.files.map((fileItem, index) => ({
                id: `${doc.id}-${index}`,
                selectedId: fileItem.id,
                name: fileItem.original_filename,
                url: fileItem.file, 
            }))
            : doc.files
                ? [{ id: doc.id, name: doc.files.original_filename, url: doc.files.file }]
                : [];

        setFileNames(LastFiles);
    };
    
    const handleDelete = async (rowKey) => {
        console.log('Deleting document with key:', rowKey);
        
        try {
            const response = await axios.delete(`${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/documents/${rowKey}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                getDocuments()
                toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document deleted successfully', life: 3000 });
            }
        } catch (err) {
            console.log(err);

        }
    }
    const handleUpdateDocument = async () => {
    if (!selectedDocument || !subject) {
        alert('Please fill all the fields.');
        return;
    }

    try {
        const formData = new FormData();

        // Document type
        const docTypeObj = documentTypes.find(dt => dt.id === selectedDocument);
        const docTypeName = docTypeObj ? docTypeObj.name : selectedDocument;
        formData.append('type', selectedDocument);
        formData.append('description', subject);

        // Append newly uploaded files
        if (uploadedFiles && uploadedFiles.length > 0) {
            uploadedFiles.forEach((file) => {
                formData.append('uploaded_files', file);
            });
        }
        if (FileNames && FileNames.length > 0) {
            FileNames.forEach((file) => {
                formData.append('files_to_keep', file.selectedId);
            });
        }

        const response = await axios.patch(
            `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/documents/${selectedDocId}/`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        if (response.status == 200 || response.status == 201) {
        getDocuments();
        setDisplayDialog(false);
        setSelectedDocument(null);
        setSubject('');
        setFileNames([]);
        setUploadedFiles([]);
        setIsEdit(false);
        }

        toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Document updated' });

    } catch (err) {
        console.error('Failed to update document', err);
        alert('Failed to update document');
    }
};
const [stages, setStages] = useState([]);
 const rowClass = (data) => {
    return {
        'bg-green-100': data.mark_as_done === true
    };
};

// const stages = [
//   { id: 1, stage: "Planning", responsiblePerson: "John", group_name: "Team A"},
//   { id: 2, stage: "Design", responsiblePerson: "Sarah", group_name: "Team B"},
//   { id: 3, stage: "Development", responsiblePerson: "David", group_name: "Team C"},
// ];
const getStages = async () => {
    try {
         const response = await axios.get(
            `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/stages/`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        if (response.status === 200) {
            setStages(response.data.results ||response.data || []);
        }
    } catch (err) {
        console.log("Error fetching stages:", err);
    }

}
useEffect(() => {
    getStages();
}, [Editid]);
const handleMarkDone = async(rowData) => {
   let req={
  "stage_name": rowData.stage_name,
  "responsible_person": rowData.responsible_person,
  "responsible_person_company": rowData.responsible_person_company_id,
  "mark_as_done": rowData.mark_as_done ? false : true
}

    try {
         const response = await axios.put(
            `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/stages/${rowData.id}/`,
            req,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        if (response.status === 200) {
            getStages();
        }
    } catch (err) {
        console.log("Error fetching stages:", err);
    }
};

const StagesActions = (row) => {
  return (
    <div className="flex gap-2">
      {/* Edit */}
      <button
        className="btn btn-sm btn-primary"
        onClick={() => onEditStage(row)}
      >
        <i className="pi pi-pencil"></i>
      </button>

      {/* Delete */}
    {!row.mark_as_done && (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => onDeleteStage(row)}
        >
          <i className="pi pi-trash"></i>
        </button>
      )}
    </div>
  );
};
const [StageEditId,setStageEditId] = useState(null)
const onEditStage = (row) => {
    setStageEditId(row.id)
    setshowStagepopup(true);
    setStageValue("statusName",row.stage_name);
    setSelectedGroup(row.group);
    getTeam(row.responsible_person_company_id)
    setSelectedresponsiblePersonCompany(row.responsible_person_company_id)
    setSelectedresponsiblePerson(row.responsible_person);
};
const onDeleteStage = async (row) => {
    console.log("Delete clicked", row);
     try {
         const response = await axios.delete(
            `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/stages/${row.id}/`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        if (response.status === 200) {
            getStages();
        }
    } catch (err) {
        console.log("Error fetching stages:", err);
    }
};

const onSubmitStages = async (data) => {
    console.log(data,'datafor stag');
    if(!selectedresponsiblePerson)
    {
        alert("Please select Responsible Person");
        return;
    }
    const formData = new FormData();
    formData.append("stage_name", data.statusName || "");
    formData.append("responsible_person_company", selectedresponsiblePersonCompany || "");
    formData.append("responsible_person", selectedresponsiblePerson || "");
    formData.append("group", selectedGroup || "");
    try {
         const isEdit = Boolean(StageEditId);

    const url = isEdit
        ? `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/stages/${StageEditId}/`
        : `${process.env.REACT_APP_Company_Contact}/company/projects/${Editid}/stages/`;

    const method = isEdit ? 'put' : 'post';

    const response = await axios({
        method,
        url,
        data: formData,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
        },
    });
    if (response.status === 200 || response.status === 201) {
    handleCancelStagePopup();
    setshowStagepopup(false);
    getStages();
}
    } catch (err) {
        console.log("Error fetching stages:", err);
    }
    
}
    return (
        <React.Fragment>
            <div className="page-content create-ajob">
                <Container fluid>
                     <Toast ref={toast} />
                    <div className="page-title-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <h1 className="page-title">Create Project</h1>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item active">
                                        Create a new project with detailed information for effective project management and team coordination.
                                    </li>
                                </ol>
                            </Col>
                            
                            {/* <Col md={6}>
                                <div className="d-flex justify-content-end">
                                    <Toast ref={toast} />
                                        <button type="submit" className="btn btn-success me-2" onClick={handleSubmit}>
                                            <i className="pi pi-save me-1"></i> Save
                                        </button>
                                    <Link to="/allactive-project">
                                        <Button
                                            color="primary"
                                            className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                            onClick={showCancel}
                                        >
                                            <i className="pi pi-times me-1"></i>
                                            Cancel
                                        </Button>
                                    </Link>
                                </div>
                            </Col> */}
                        </Row>
                    </div>

                    <Row>
                        {/* Project Information */}
                        <Col xl={5}>
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Project Information</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div>
                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="projectCode">Project Code</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="projectCode"
                                                            value={projectCode}
                                                            onChange={(e) => setProjectCode(e.target.value)}
                                                            className="w-full"
                                                            style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="projectName">Project Name</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="projectName"
                                                            value={projectName}
                                                            onChange={(e) => setProjectName(e.target.value)}
                                                            className="w-full"
                                                            style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>

                                                {/* <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="module">Module</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="project"
                                                            value={selectedModule}
                                                            onChange={(e) => setSelectedModule(e.value)}
                                                            options={[
                                                                ...moduleWorkTypes,
                                                                { id: 'add', name: 'Add New', icon: 'pi pi-plus' },
                                                                ...(selectedModule ? [{ id: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                            ]}
                                                            placeholder="Select Module"
                                                            className="w-full bgclr"
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            filter
                                                            itemTemplate={(option) => (
                                                                <div className="flex align-items-center gap-2">
                                                                    {option?.icon && <i className={option.icon}></i>}
                                                                    <span>{option.name}</span>
                                                                </div>
                                                            )}
                                                        /> */}

                                                        {/* <MultiSelect
                                                            id="project"
                                                            value={selectedModule}   // should be an array
                                                            onChange={(e) => setSelectedModule(e.value)}
                                                            options={[
                                                                ...moduleWorkTypes,
                                                                { id: 'add', name: 'Add New', icon: 'pi pi-plus' },
                                                                ...(selectedModule?.length ? [{ id: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                            ]}
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            placeholder="Select Modules"
                                                            maxSelectedLabels={10} 
                                                            className="w-full  mt-2 bgclr"
                                                            display="comma"
                                                            itemTemplate={(option) => (
                                                                <div className="flex align-items-center gap-2">
                                                                    {option?.icon && <i className={option.icon}></i>}
                                                                    <span>{option.name}</span>
                                                                </div>
                                                            )}
                                                        /> */}

                                                        {/* <WorkType1
                                                            initialWorkTypes={moduleWorkTypes}
                                                            dropdownWorkTypes={moduleDropdownWorkTypes}
                                                            onWorkTypesChange={handleModuleWorkTypesChange}
                                                            onSelectionChange={handleModuleSelectionChange}
                                                        /> */}
                                                    {/* </Col>
                                                </Row> */}

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="company">Project Manager Company</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="company"
                                                            value={selectedCompany}
                                                            options={compamyitem}
                                                            onChange={e => {setSelectedCompany(e.value); getProjectManager(e.value)}}
                                                            optionLabel="label"
                                                            optionValue="id"
                                                            placeholder="Select Company"
                                                            className="w-full"
                                                             style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="projectManager">Project Manager</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="project"
                                                            value={selectedProjectManager}
                                                            onChange={(e) => setSelectedProjectManager(e.value)}
                                                            options={ProjectManagerOptions}
                                                            placeholder="Select Manager"
                                                            className="w-full bgclr"
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            filter
                                                            style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="company">Delivery Manager Company</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="company"
                                                            value={selectedDeliveryCompany}
                                                            options={compamyitem}
                                                            onChange={e => {setSelectedDeliveryCompany(e.value); getDeliveryManager(e.value)}}
                                                            optionLabel="label"
                                                            optionValue="id"
                                                            placeholder="Select Company"
                                                            className="w-full"
                                                             style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="deliveryManager">Delivery Manager</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="deliveryManager"
                                                            value={selectedDeliveryManager}
                                                            onChange={(e) => setSelectedDeliveryManager(e.value)}
                                                            options={DeliveryManagerOptions}
                                                            placeholder="Select Manager"
                                                            className="w-full bgclr"
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            filter
                                                            style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>
                                                 <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="deliveryManager">Document</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                    <input
                                                     ref={fileRef}
                                                        type="file"
                                                        className="form-control createProjectFileUpload"
                                                        name="createProjectFileUpload"
                                                        id="createProjectFileUpload"
                                                        accept=".pdf, .doc, .docx, .xls, .xlsx, .zip"
                                                        onChange={(e) => { setUploadedFiles(e.target.files[0])}}
                                                    />
                                                    </Col>
                                                    {/* {uploadedFiles !== null && <div className=''>
                                                        <a href={uploadedFiles?.name || uploadedFiles} target="_blank" rel="noopener noreferrer">{uploadedFiles?.name ||uploadedFiles }  <span
                                                            className='text-danger'
                                                            onClick={() => {
                                                                setUploadedFiles(null);
                                                                fileRef.current.value = ""; 
                                                            }}>
                                                            <i className='fa fa-close'></i> 
                                                        </span> </a>
                                                    </div>
                                                    } */}
                                                    {uploadedFiles && (
                                                        <div>
                                                            <a
                                                                href={
                                                                    uploadedFiles instanceof File
                                                                        ? URL.createObjectURL(uploadedFiles)
                                                                        : uploadedFiles?.name || uploadedFiles
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {uploadedFiles?.name || uploadedFiles}

                                                                <span
                                                                    className="text-danger"
                                                                    onClick={() => {
                                                                        setUploadedFiles(null);
                                                                        fileRef.current.value = "";
                                                                    }}
                                                                    style={{ marginLeft: 8, cursor: "pointer" }}
                                                                >
                                                                    <i className="fa fa-close"></i>
                                                                </span>
                                                            </a>
                                                        </div>
                                                    )}

                                                </Row>
                                                {/* <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="projectStatus">Project Status</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Dropdown
                                                            id="project"
                                                            value={selectedProjectStatus}
                                                            onChange={(e) => setSelectedProjectStatus(e.value)}
                                                            options={statusWorkTypes}
                                                            placeholder="Select Project Status"
                                                            className="w-full bgclr"
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            filter
                                                            itemTemplate={(option) => (
                                                                <div className="flex align-items-center gap-2">
                                                                    {option?.icon && <i className={option.icon}></i>}
                                                                    <span>{option.name}</span>
                                                                </div>
                                                            )}
                                                        /> */}
                                                        {/* <WorkType1
                                                            initialWorkTypes={statusWorkTypes}
                                                            dropdownWorkTypes={statusDropdownWorkTypes}
                                                            onWorkTypesChange={handleStatusWorkTypesChange}
                                                            onSelectionChange={handleStatusSelectionChange}
                                                        /> */}
                                                    {/* </Col>
                                                </Row> */}
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Project Timeline</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div>
                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="startDate">Start Date</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Calendar
                                                            id="startDate"
                                                            value={startDate}
                                                            onChange={(e) => setStartDate(e.value)}
                                                            dateFormat="dd/mm/yy"
                                                            placeholder="Select start date"
                                                            className="w-full activejobdrop"
                                                            style={{ border: '1px solid #ced4da' }}
                                                            showIcon
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="endDate">End Date</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Calendar
                                                            id="endDate"
                                                            value={endDate}
                                                            minDate={startDate}
                                                            onChange={(e) => setEndDate(e.value)}
                                                            dateFormat="dd/mm/yy"
                                                            placeholder="Select end date"
                                                            className="w-full activejobdrop"
                                                            style={{ border: '1px solid #ced4da' }}
                                                            showIcon
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="extendedEndDate">Extended End Date</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Calendar
                                                            id="extendedEndDate"
                                                            value={extendedEndDate}
                                                            minDate={endDate || startDate}
                                                            onChange={(e) => setExtendedEndDate(e.value)}
                                                            dateFormat="dd/mm/yy"
                                                            placeholder="Select extended date"
                                                            className="w-full activejobdrop"
                                                            style={{ border: '1px solid #ced4da' }}
                                                            showIcon
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="reasonForDelay">Reason for Delay</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="reasonForDelay"
                                                            value={reasonForDelay}
                                                            onChange={(e) => setReasonForDelay(e.target.value)}
                                                            className="w-full"
                                                            style={{ border: '1px solid #ced4da' }}
                                                            placeholder="Optional explanation for delay"
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Documents start */}

{/* 
                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Project Documents</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div>
                                                <DataTable
                                                    value={documents}
                                                    rows={5}
                                                    className="p-datatable-gridlines"
                                                    emptyMessage={<div className="empty-message-custom">No documents found.</div>}
                                                >
                                                    <Column
                                                        field="type_name"
                                                        header="Document Type"
                                                    />
                                                    <Column
                                                        field="description"
                                                        header="Subject"
                                                    />
                                                    <Column
                                                        field="created_at"
                                                        header="Uploaded On"
                                                        body={(rowData) => new Date(rowData.created_at).toLocaleDateString()}
                                                    />
                                                    <Column
                                                        header="Attachments"
                                                        body={(rowData) => rowData.files && rowData.files.length > 0 ? (
                                                            <ul className="list-unstyled mb-0">
                                                                {rowData.files.map((fileItem) => (
                                                                    <li key={fileItem.id}>
                                                                        <a href={fileItem.file} target="_blank" rel="noopener noreferrer">
                                                                            {fileItem.original_filename} ({(fileItem.file_size / 1024).toFixed(2)} KB)
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        ) : 'No file'}
                                                    />
                                                    <Column
                                                        header="Actions"
                                                        body={(rowData) => (
                                                            <div className="d-flex gap-2">
                                                                <Button
                                                                    type="button"
                                                                    icon="pi pi-pencil"
                                                                    className="p-button-rounded p-button-text p-button-info"
                                                                    tooltip="Edit"
                                                                    onClick={() => handleEdit(rowData)}
                                                                />
                                                                <Button
                                                                    icon="pi pi-trash"
                                                                    className="p-button-rounded p-button-text p-button-danger"
                                                                    tooltip="Delete"
                                                                    type="button"
                                                                    onClick={() => handleDelete(rowData.id)}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                </DataTable>
                                                <div className="block d-flex justify-content-end align-items-center">
                                                    <a color="primary" className="anchr-title mt-3" onClick={openAddDocumentDialog}>
                                                        <i className="pi pi-plus me-1"></i> Add More
                                                    </a>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>

                                <Dialog
                                    header="Add Document"
                                    visible={displayDialog}
                                    onHide={closeAddDocumentDialog}
                                    style={{ width: "30vw" }}
                                    footer={
                                        <div className="d-flex justify-content-end gap-2">
                                            {isEdit ? <Button color="primary btn-main mr-2" onClick={handleUpdateDocument}>
                                                <i className="pi pi-pencil me-1"></i>
                                                Update
                                            </Button> :
                                                <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                                                    <i className="pi pi-plus me-1"></i>
                                                    Add Document
                                                </Button>}
                                            <Button color="btn btn-primary cancel-outlinebtn" onClick={closeAddDocumentDialog}>
                                                <i className="pi pi-times me-1"></i>
                                                Cancel
                                            </Button>
                                        </div>
                                    }
                                >
                                    <Row className="mt-2 align-items-center">
                                        <Col xl={3}>
                                            <label htmlFor="type" className="block mb-2">
                                                Type
                                            </label>
                                        </Col>
                                        <Col xl={9}>
                                           
                                            <Dropdown
                                                id="project"
                                                value={selectedDocument}
                                                onChange={(e) => setSelectedDocument(e.value)}
                                                options={[
                                                    ...documentTypes,
                                                    { code: 'add', name: 'Add New', icon: 'pi pi-plus' },
                                                    ...(selectedDocument ? [{ code: 'edit', name: 'Edit Selected', icon: 'pi pi-pencil' }] : []),
                                                ]}
                                                placeholder="Select Document Type"
                                                className="w-full bgclr"
                                                optionLabel="name"
                                                optionValue="code"
                                                filter
                                                itemTemplate={(option) => (
                                                    <div className="flex align-items-center gap-2">
                                                        {option?.icon && <i className={option.icon}></i>}
                                                        <span>{option.name}</span>
                                                    </div>
                                                )}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-2 align-items-center">
                                        <Col xl={3}>
                                            <label htmlFor="subject" className="block mb-2">
                                                Description
                                            </label>
                                        </Col>
                                        <Col xl={9}>
                                            <InputText
                                                id="subject"
                                                value={subject}
                                                onChange={(e) => setSubject(e.target.value)}
                                                className="w-full"
                                                style={{ border: '1px solid #ced4da' }}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-2 align-items-center">
                                        <Col xl={3}>
                                            <label htmlFor="documentAttachment" className="block mb-2">
                                                File Attachment
                                            </label>
                                        </Col>
                                        <Col xl={9}>
                                            <FileUpload
                                                ref={fileUploadRef}
                                                name="files[]"
                                                accept="image/jpg,image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                maxFileSize={5242880}
                                                multiple
                                                customUpload
                                                auto={false}
                                                onSelect={(e) => {
                                                    const currentFiles = uploadedFiles || [];
                                                    const newFiles = e.files || [];

                                                    // Calculate total size including existing files
                                                    const currentTotalSize = currentFiles.reduce((total, file) => total + (file.size || 0), 0);
                                                    const newTotalSize = newFiles.reduce((total, file) => total + (file.size || 0), 0);
                                                    const totalSize = currentTotalSize + newTotalSize;

                                                    // Check total size limit (5MB = 5,242,880 bytes)
                                                    if (totalSize > 5242880) {
                                                        toast.current?.show({
                                                            severity: 'error',
                                                            summary: 'File Size Error',
                                                            detail: `Total file size exceeds 5MB limit. Current total: ${(totalSize / 1024 / 1024).toFixed(2)}MB`
                                                        });

                                                        // Clear the new selection but preserve existing files
                                                        if (fileUploadRef.current) {
                                                            fileUploadRef.current.clear();
                                                            if (currentFiles.length > 0) {
                                                                fileUploadRef.current.setFiles(currentFiles);
                                                            }
                                                        }
                                                        return;
                                                    }

                                                    // Check file types
                                                    const allowedTypes = [
                                                        'image/jpeg', 'image/jpg', 'image/png',
                                                        'application/pdf',
                                                        'application/msword',
                                                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                                        'text/plain',
                                                        'application/vnd.ms-excel',
                                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                                    ];

                                                    const invalidFiles = newFiles.filter(file => !allowedTypes.includes(file.type));
                                                    if (invalidFiles.length > 0) {
                                                        toast.current?.show({
                                                            severity: 'error',
                                                            summary: 'Invalid File Type',
                                                            detail: `Invalid file types: ${invalidFiles.map(f => f.name).join(', ')}. Only Images, PDF, DOC, DOCX, TXT, XLS, XLSX are allowed.`
                                                        });

                                                        // Clear the new selection but preserve existing files
                                                        if (fileUploadRef.current) {
                                                            fileUploadRef.current.clear();
                                                            if (currentFiles.length > 0) {
                                                                fileUploadRef.current.setFiles(currentFiles);
                                                            }
                                                        }
                                                        return;
                                                    }

                                                    // All validations passed, update the files
                                                    const combinedFiles = [...currentFiles, ...newFiles];
                                                    setUploadedFiles(combinedFiles);
                                                }}
                                                uploadHandler={(e) => {
                                                    console.log("Upload handler called", e.files);
                                                }}
                                                onClear={() => {
                                                    console.log("Files cleared");
                                                    setUploadedFiles([]);
                                                }}
                                            />
                                            <small className="text-muted">
                                                Maximum total file size: 5MB. Accepted formats: Images (JPG, JPEG, PNG), PDF, DOC, DOCX, TXT, XLS, XLSX
                                            </small>
                                        </Col>
                                    </Row>
                                    {FileNames && FileNames.length > 0 && (
                                        <Row className="mt-2 align-items-center">
                                            <Col xl={3}>
                                                <label className="block mb-2">Previously Attached Files</label>
                                            </Col>
                                            <Col xl={9}>
                                                {FileNames.map((file) => (
                                                    <div key={file.id} className="d-flex align-items-center mb-2">
                                                        <a
                                                            href={file.url || file.name} // use URL if available
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="me-2"
                                                        >
                                                            {file.name.split('/').pop()}
                                                        </a>
                                                        <i
                                                            className="pi pi-times"
                                                            style={{ cursor: "pointer", color: "red" }}
                                                            onClick={() => {
                                                                // Remove the clicked file from FileNames
                                                                setFileNames(prev => prev.filter(f => f.id !== file.id));
                                                            }}
                                                        ></i>
                                                    </div>
                                                ))}
                                            </Col>

                                        </Row>
                                    )}
                                </Dialog>
                            </Card> */}


                            {/* Documents end */}

                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">System Fields</h4>
                                    <Row>
                                        <Col xl={12}>
                                            <div>
                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="createdBy">Created By</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="createdBy"
                                                            value={createdBy}
                                                            readOnly
                                                            className="w-full"
                                                            style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="createdDate">Created Date</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Calendar
                                                            id="createdDate"
                                                            value={createdDate}
                                                            readOnlyInput
                                                            dateFormat="dd/mm/yy"
                                                            className="w-full activejobdrop"
                                                            style={{ border: '1px solid #ced4da' }}
                                                            showIcon
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="lastModifiedBy">Last Modified By</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <InputText
                                                            id="lastModifiedBy"
                                                            value={lastModifiedBy}
                                                            readOnly
                                                            className="w-full"
                                                            style={{ border: '1px solid #ced4da' }}
                                                        />
                                                    </Col>
                                                </Row>

                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="lastModifiedDate">Last Modified Date</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <Calendar
                                                            id="lastModifiedDate"
                                                            value={lastModifiedDate}
                                                            minDate={startDate}
                                                            readOnlyInput
                                                            dateFormat="dd/mm/yy"
                                                            className="w-full activejobdrop"
                                                            style={{ border: '1px solid #ced4da' }}
                                                            showIcon
                                                        />
                                                    </Col>
                                                </Row>

                                                {/* <Row className="justify-content-start align-items-end mt-0">
                                                    <Col xl={12}>
                                                        <div className="d-flex align-items-center mt-1">
                                                            <Checkbox
                                                                inputId="checkbox"
                                                                checked={popchecked2}
                                                                onChange={handlePopupCheckbox2}
                                                            />
                                                            <label htmlFor="username" className="ms-1 mt-2">
                                                                Private
                                                            </label>
                                                        </div>
                                                    </Col>

                                                    {popchecked2 && (
                                                        <Col xl={12}>

                                                             <Row className="mt-2 align-items-center">
                                                    <Col xl={3}>
                                                        <label htmlFor="username">User Id's</label>
                                                    </Col>
                                                    <Col xl={9}>
                                                        <MultiSelect
                                                                value={privateDrop}
                                                                onChange={e => setPrivateDrop(e.value)}
                                                                options={PrivetDropdownValues}
                                                                optionLabel={(option) =>` ${option.name} (${option.email})` }
                                                                optionValue="code"
                                                                placeholder="Select Users"
                                                                className="w-full"
                                                                style={{border: '1px solid #ced4da'}}
                                                                display="comma"
                                                            />
                                                    </Col>
                                                </Row>
                                                           
                                                            
                                                        </Col>
                                                    )}
                                                </Row> */}
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                             {/* Notes start */}


                            {/* <Card className="bg-form">
                                <CardBody>



                                    <Row>
                                        <Col lg={12}>

                                            <h4 className="card-title mb-3">Notes</h4>
                                            
                                        </Col>
                                    </Row>

                                    {isEditorVisible && (
                                        <Row className="mt-4">
                                            <Col lg={12}>
                                                <Editor
                                                    value={editorContent}
                                                    onTextChange={e => setEditorContent(e.htmlValue)}
                                                    style={{ height: "200px" }}
                                                    placeholder="Enter your notes here..."
                                                    headerTemplate={header}
                                                />
                                                <div className="d-flex justify-content-end mt-2">
                                                    <PrimeButton
                                                        type="button"
                                                        label={saveLoading ? "Saving..." : "Save"}
                                                        icon={saveLoading ? "pi pi-spinner pi-spin" : "pi pi-save"}
                                                        className="p-button p-button-success me-2"
                                                        onClick={handleSaveNotes}
                                                        disabled={saveLoading}
                                                        style={{
                                                            backgroundColor: '#28a745',
                                                            border: '1px solid #28a745',
                                                            color: 'white',
                                                            padding: '0.5rem 1rem',
                                                            borderRadius: '0.25rem',
                                                            marginRight: '0.5rem'
                                                        }}
                                                    />
                                                    <PrimeButton
                                                        type="button"
                                                        label="Cancel"
                                                        icon="pi pi-times"
                                                        className="p-button p-button-secondary"
                                                        onClick={handleCancelNotes}
                                                        style={{
                                                            backgroundColor: '#6c757d',
                                                            border: '1px solid #6c757d',
                                                            color: 'white',
                                                            padding: '0.5rem 1rem',
                                                            borderRadius: '0.25rem'
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    <Row className="mt-4 notes">
                                        <Col lg={12}>
                                            {notesLoading ? (
                                                <div className="d-flex justify-content-center p-4">
                                                    <i className="pi pi-spinner pi-spin" style={{ fontSize: '2rem' }}></i>
                                                    <span className="ml-2">Loading notes...</span>
                                                </div>
                                            ) : projectNotes.length > 0 ? (
                                                <Card className="p-3">
                                                    {projectNotes.map((note, index) => (
                                                        <div key={note.id || index}>
                                                            <div className="d-flex mt-0">
                                                                <strong className="text-muted me-4">
                                                                    {note.candidateName}
                                                                </strong>
                                                                <strong className="text-muted">
                                                                    {note.timestamp}
                                                                </strong>
                                                            </div>
                                                            <div className="d-flex justify-content-between mt-2 mb-0">
                                                                <div
                                                                    style={{
                                                                        flex: 1,
                                                                        wordWrap: 'break-word',
                                                                        wordBreak: 'break-all',
                                                                        overflowWrap: 'break-word',
                                                                        maxWidth: 'calc(100% - 60px)',
                                                                        marginRight: '10px'
                                                                    }}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: note.content,
                                                                    }}
                                                                />
                                                                <div className="d-flex align-items-center" style={{ flexShrink: 0 }}>
                                                                    <PrimeButton
                                                                        icon="pi pi-pencil"
                                                                        className="p-button p-button-warning p-button-sm"
                                                                        onClick={() => handleEditNote(index)}
                                                                        tooltip="Edit Note"
                                                                        tooltipOptions={{ position: 'top' }}
                                                                        style={{
                                                                            // backgroundColor: '#ffc107',
                                                                            // border: '1px solid #ffc107',
                                                                            color: '#212529',
                                                                            padding: '0.rem 0.3rem',
                                                                            borderRadius: '0.2rem',
                                                                            marginRight: '0.3rem',
                                                                            fontSize: '0.75rem',
                                                                            minWidth: 'auto',
                                                                            height: '24px',
                                                                            width: '24px'
                                                                        }}
                                                                    />
                                                                    <PrimeButton
                                                                        icon="pi pi-trash"
                                                                        className="p-button p-button-danger p-button-sm"
                                                                        onClick={() => confirmDeleteNote(index)}
                                                                        tooltip="Delete Note"
                                                                        tooltipOptions={{ position: 'top' }}
                                                                        style={{
                                                                            // backgroundColor: '#dc3545',
                                                                            // border: '1px solid #dc3545',
                                                                            color: '#212529',
                                                                            padding: '0.15rem 0.3rem',
                                                                            borderRadius: '0.2rem',
                                                                            fontSize: '0.75rem',
                                                                            minWidth: 'auto',
                                                                            height: '24px',
                                                                            width: '24px'
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {index < projectNotes.length - 1 && <hr />}
                                                        </div>
                                                    ))}
                                                </Card>
                                            ) : (
                                                !Editid ? (
                                                    <div className="text-center p-4 text-muted">
                                                        <i className="pi pi-info-circle" style={{ fontSize: '1.5rem' }}></i>
                                                        <p className="mt-2">Save the project first to add notes</p>
                                                    </div>
                                                ) : (
                                                    <div className="text-center p-4 text-muted">
                                                        <i className="pi pi-file-o" style={{ fontSize: '1.5rem' }}></i>
                                                        <p className="mt-2">No notes available. Click "Add Notes" to create your first note.</p>
                                                    </div>
                                                )
                                            )}
                                        </Col>
                                    </Row>

                                      <Row>
                                        <Col lg={12}>

                                            <div className="d-flex justify-content-end">
                                                <PrimeButton
                                                    type="button"
                                                    label="Add Notes"
                                                    icon="pi pi-plus"
                                                    className="p-button p-button-primary add-notes-btn"
                                                    onClick={handleAddNotes}
                                                    disabled={!Editid}
                                                    tooltip={!Editid ? "Save the project first to add notes" : ""}
                                                    tooltipOptions={{ position: 'top' }}
                                                    style={{
                                                        backgroundColor: !Editid ? '#cccccc' : '#e0e0ea',
                                                        border: !Editid ? '1px solid #cccccc' : '1px solid #e0e0ea',
                                                        color: !Editid ? '#666666' : '#000000',
                                                        padding: '0.5rem 1rem',
                                                        borderRadius: '0.25rem',
                                                        transition: 'all 0.3s ease',
                                                        cursor: !Editid ? 'not-allowed' : 'pointer'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (Editid) {
                                                            e.target.style.backgroundColor = '#ffffff';
                                                            e.target.style.color = '#000000';
                                                            e.target.style.border = '1px solid #ffffff';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (Editid) {
                                                            e.target.style.backgroundColor = '#e0e0ea';
                                                            e.target.style.color = '#000000';
                                                            e.target.style.border = '1px solid #e0e0ea';
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card> */}

                            {/* Notes Delete Confirmation Dialog */}
                            <ConfirmDialog
                                visible={confirmDialog.visible}
                                onHide={() => setConfirmDialog({ visible: false, noteIndex: null })}
                                message="Are you sure you want to delete this note?"
                                header="Delete Confirmation"
                                icon="pi pi-exclamation-triangle"
                                accept={() => handleDeleteNote(confirmDialog.noteIndex)}
                                reject={() => setConfirmDialog({ visible: false, noteIndex: null })}
                                acceptClassName="p-button-danger"
                                acceptLabel="Delete"
                                rejectLabel="Cancel"
                            />


                            {/* Notes end */}
                            {loader ?
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backdropFilter: "blur(1px)",  // 💥 BLUR BACKGROUND
                                        backgroundColor: "rgba(255, 255, 255, 0.4)", // soft overlay
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 9999
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "45px",
                                            height: "45px",
                                            border: "4px solid #ddd",
                                            borderTopColor: "#126fa9",
                                            borderRadius: "50%",
                                            animation: "spin 0.8s linear infinite"
                                        }}
                                    ></div>
                                </div> : ""
                            }
                        </Col>
                        {/* Project Description */}
                        <Col xl={7}>
                            <Card className="bg-form screening-que">
                                <CardBody>
                                    <h4 className="card-title mb-3">Project Description</h4>
                                    <div className="add-que-card mb-4">
                                        <Row>
                                            <Col xl={12}>
                                                {/* <Row className="sidebar d-flex align-items-center">
                                                    <Col xl={6}>
                                                        <label htmlFor="description" className="block mb-2">
                                                            Description
                                                        </label>
                                                    </Col>
                                                    <Col lg={6} className="d-flex justify-content-end mt-2">
                                                        <Button color="primary" className="btn btn-primary aibtn">
                                                            <i className="pi pi-star me-1"></i>
                                                            Write with AI
                                                        </Button>
                                                    </Col>
                                                </Row> */}
                                                <Row className="mt-2 align-items-center">
                                                    <Col xl={12}>
                                                        <div className="p-field mb-0">
                                                            <Editor
                                                                value={content}
                                                                onTextChange={handleEditorChange}
                                                                headerTemplate={header}
                                                                style={{ height: '200px' }}
                                                                className="w-full"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </div>
                                    <ConfirmDialog />
                                </CardBody>
                            </Card>

                            <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Project Stages / Levels</h4>
                                    <div
                                            className="flex justify-content-end align-items-center mb-3"
                                            style={{ border: 'none', background: 'transparent', boxShadow: 'none' }}
                                          >
                                            <Button 
                                              icon="pi pi-plus" 
                                              label="Add Stage" 
                                              onClick={() => setshowStagepopup(true)}
                                            />
                                          </div>
                                    <DataTable
                                        value={stages}
                                        responsiveLayout="scroll"
                                        className=""
                                        rowClassName={rowClass}
                                    >
                                        <Column field="stage_name" header="Stage / Level"  />
                                        <Column field="responsible_person_name" header="Responsible Person"  />
                                        <Column field="group_name" header="Group"  />
                                        <Column
                                            header="Mark As Done"
                                            body={(rowData) => (
                                                <Checkbox
                                                    checked={rowData.mark_as_done}
                                                    onChange={() => handleMarkDone(rowData)}
                                                />
                                            )}
                                        /><Column
                                            header="Completed Date"
                                            body={(row) =>
                                                row.mark_as_done ? (
                                                    <span className="font-semibold">
                                                        {new Date(row.updated_at).toLocaleDateString('en-GB').replace(/\//g, '-')}
                                                    </span>
                                                ) : (
                                                    <span className="text-orange-600 font-semibold">
                                                        ---
                                                    </span>
                                                )
                                            }
                                        />

                                        <Column
                                            header="Actions"
                                            body={(rowData) => StagesActions(rowData)}
                                            style={{ width: "130px", textAlign: "center" }}
                                        />
                                    </DataTable>

                                </CardBody>
                            </Card>

                            {/* phases start */}

                            {/* <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2">Project Execution Phases</h4>
                                    <EstimateTable id={Editid} />
                                </CardBody>
                            </Card> */}

                            {/* phases end */}


                                {/* phases delay start */}

                            {/* <Card className="bg-form">
                                <CardBody>
                                    <h4 className="card-title mb-2"> Reason for Delay</h4>
                                    <EstimateDelay id={Editid} />
                                </CardBody>

                                

                                <Dialog
                                    header="Add Document"
                                    visible={displayDialog1}
                                    onHide={closeAddDocumentDialog}
                                    style={{ width: "30vw" }}
                                    footer={
                                        <div>
                                            <Button color="primary btn-main mr-2" onClick={handleAddDocument}>
                                                Add Document
                                            </Button>
                                            <Button color="btn btn-primary cancel-outlinebtn" onClick={closeAddDocumentDialog}>
                                                <i className="pi pi-times me-1"></i>
                                                Cancel
                                            </Button>
                                        </div>
                                    }
                                >
                                    <Row className="mt-2 align-items-center">
                                        <Col xl={3}>
                                            <label htmlFor="type" className="block mb-2">
                                                Type
                                            </label>
                                        </Col>
                                        <Col xl={9}>
                                            <Dropdown
                                                value={selectedDocument}
                                                onChange={(e) => setSelectedDocument(e.value)}
                                                options={groupedDocuments}
                                                optionLabel="label"
                                                optionGroupLabel="label"
                                                optionGroupChildren="items"
                                                optionGroupTemplate={groupedItemTemplate}
                                                className="w-full bgclr"
                                                style={{ border: '1px solid #ced4da' }}
                                                placeholder="Select a Document"
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-2 align-items-center">
                                        <Col xl={3}>
                                            <label htmlFor="subject" className="block mb-2">
                                                Description
                                            </label>
                                        </Col>
                                        <Col xl={9}>
                                            <InputText
                                                id="subject"
                                                value={subject}
                                                onChange={(e) => setSubject(e.target.value)}
                                                className="w-full"
                                                style={{ border: '1px solid #ced4da' }}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-2 align-items-center">
                                        <Col xl={3}>
                                            <label htmlFor="attachment" className="block mb-2">
                                                Attachment
                                            </label>
                                        </Col>
                                        <Col xl={9}>
                                            <FileUpload
                                                mode="basic"
                                                name="demo[]"
                                                url="/api/upload"
                                                
                                                maxFileSize={1000000}
                                                onUpload={handleUpload}
                                                customUpload
                                                uploadHandler={customBase64Uploader2}
                                                className="custom-fileupload"
                                            />
                                        </Col>
                                    </Row>
                                </Dialog>
                            </Card> */}

                            {/* pharses delay end */}


                           


                        </Col>


                    </Row>

                    <Row className="align-items-center mb-3">
                        <Col md={12}>
                            <div className="d-flex justify-content-end">
                                <button type="submit" className="btn btn-success me-2" onClick={handleSubmit} disabled={saveLoading}>
                                    <i className="pi pi-save me-1"></i>Save
                                </button>
                                <Link to="/allactive-project">
                                    <Button
                                        color="primary"
                                        className="btn btn-primary waves-effect waves-light me-2 cancel-outlinebtn"
                                        // onClick={showCancel}
                                        disabled={saveLoading}
                                    >
                                        <i className="pi pi-times me-1"></i>
                                        Cancel
                                    </Button>
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </Container>

                {/* Add New Phase Dialog */}
                <Dialog
                    header="Add New Phase"
                    visible={phaseDialog}
                    onHide={closeAddPhaseDialog}
                    style={{ width: "40vw", maxWidth: "600px" }}
                    footer={
                        <div>
                            <PrimeButton
                                label="Cancel"
                                icon="pi pi-times"
                                onClick={closeAddPhaseDialog}
                                className="p-button-secondary"
                                style={{
                                    backgroundColor: '#6c757d',
                                    border: '1px solid #6c757d',
                                    color: 'white',
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0.25rem',
                                    marginRight: '0.5rem'
                                }}
                            />
                            <PrimeButton
                                label="Save"
                                icon="pi pi-check"
                                onClick={() => {
                                    // Add save logic here if needed
                                    closeAddPhaseDialog();
                                }}
                                className="p-button-success"
                                style={{
                                    backgroundColor: '#28a745',
                                    border: '1px solid #28a745',
                                    color: 'white',
                                    padding: '0.5rem 1rem',
                                    borderRadius: '0.25rem'
                                }}
                            />
                        </div>
                    }
                >
                    <Row className="mt-2 align-items-center">
                        <Col xl={12}>
                            <label htmlFor="phaseName" className="block mb-2">
                                Phase *
                            </label>
                            <InputText
                                id="phaseName"
                                value={currentPhase.phase}
                                onChange={(e) => setCurrentPhase({ ...currentPhase, phase: e.target.value })}
                                className="w-full"
                                style={{ border: '1px solid #ced4da' }}
                                placeholder="Enter phase name"
                            />
                        </Col>
                    </Row>

                    <Row className="mt-3 align-items-center">
                        <Col xl={6}>
                            <label htmlFor="phaseStartDate" className="block mb-2">
                                Start Date
                            </label>
                            <Calendar
                                id="phaseStartDate"
                                value={currentPhase.startDate}
                                onChange={(e) => setCurrentPhase({ ...currentPhase, startDate: e.value })}
                                dateFormat="dd/mm/yy"
                                placeholder="Select start date"
                                className="w-full activejobdrop"
                                style={{ border: '1px solid #ced4da' }}
                                showIcon
                            />
                        </Col>
                        <Col xl={6}>
                            <label htmlFor="phaseEndDate" className="block mb-2">
                                End Date
                            </label>
                            <Calendar
                                id="phaseEndDate"
                                value={currentPhase.endDate}
                                onChange={(e) => setCurrentPhase({ ...currentPhase, endDate: e.value })}
                                dateFormat="dd/mm/yy"
                                placeholder="Select end date"
                                className="w-full activejobdrop"
                                style={{ border: '1px solid #ced4da' }}
                                showIcon
                                minDate={currentPhase.startDate}
                            />
                        </Col>
                    </Row>

                    <Row className="mt-3 align-items-center">
                        <Col xl={12}>
                            <label htmlFor="phaseDeliverables" className="block mb-2">
                                Deliverables
                            </label>
                            <Chips
                                id="phaseDeliverables"
                                value={currentPhase.deliverables || []}
                                onChange={(e) => setCurrentPhase({ ...currentPhase, deliverables: e.value || [] })}
                                className="w-full"
                                style={{ border: '1px solid #ced4da' }}
                                separator=","
                                placeholder="Type deliverable and press Enter to add"
                                addOnBlur={true}
                            />
                            <small className="text-muted mt-1 block">Press Enter or Tab after typing each deliverable</small>
                        </Col>
                    </Row>

                    <Row className="mt-3 align-items-center">
                        <Col xl={12}>
                            <label htmlFor="phaseResponsible" className="block mb-2">
                                Responsible
                            </label>
                            <Dropdown
                                id="phaseResponsible"
                                value={currentPhase.responsible}
                                options={responsibleOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={(e) => setCurrentPhase({ ...currentPhase, responsible: e.value })}
                                placeholder="Select Responsible"
                                className="w-full bgclr"
                                style={{ border: '1px solid #ced4da' }}
                                filter
                                showClear
                            />
                        </Col>
                    </Row>
                </Dialog>
                <Dialog
                    header={
                        editingLookup
                            ? lookupModalContext === "project_groups"
                                ? "Edit Group"
                                : lookupModalContext === "project_status"
                                    ? "Edit Status"
                                    : lookupModalContext === "contact_document_type"
                                        ? "Edit Document Type"
                                        : "Edit"
                            : lookupModalContext === "project_groups"
                                ? "Add Group"
                                : lookupModalContext === "project_status"
                                    ? "Add Status"
                                    : lookupModalContext === "contact_document_type"
                                        ? "Add Document Type"
                                        : "Add"
                    }
                    visible={lookupModalVisible}
                    style={{ width: "30vw" }}
                    onHide={() => { setLookupModalVisible(false); setdescription(''); setLastSelectedLookupId(null); }}
                >
                    <div className="p-fluid">
                        {/* Dropdown - only visible when editing */}
                        {editingLookup && (
                            <>
                                <label className="mb-1">Select to edit</label>
                                <Dropdown
                                    id="worktype"
                                    value={SelectedEditdrop}
                                    onChange={(e) => {
                                        setSelectedEditdrop(e.value);
                                        const selectedOption = selecteddropoptions.find(opt => opt.id === e.value);
                                        if (selectedOption) {
                                            setLookupFormValue(selectedOption.name);
                                        }
                                    }}
                                    options={selecteddropoptions}
                                    placeholder="Select"
                                    className="w-full bgclr mb-2"
                                    optionLabel='name'
                                    optionValue="id"
                                    filter
                                />
                            </>
                        )}

                        {/* Name field */}
                        <label className="mb-1">
                            {lookupModalContext === "project_groups"
                                ? "Group Name"
                                : lookupModalContext === "project_status"
                                    ? "Status Name"
                                    : lookupModalContext === "contact_document_type"
                                        ? "Document Type Name"
                                        : "Name"} <span className="text-danger">*</span>
                        </label>
                        <InputText
                            value={lookupFormValue}
                            onChange={(e) => setLookupFormValue(e.target.value)}
                            className="w-full mb-3"
                        />

                        {/* Description */}
                        <label className="mb-1">Description</label>
                        <InputTextarea
                            value={description}
                            onChange={(e) => setdescription(e.target.value)}
                            rows={3}
                            className="w-full"
                        />
                    </div>

                    {/* Buttons */}
                    <div className="gap-2 d-flex justify-content-end mt-3">
                        <PrimeButton
                            label="Cancel"
                            className="p-button-text"
                            onClick={() => setLookupModalVisible(false)}
                        />
                        <PrimeButton label="Save" className="p-ml-2" onClick={handleLookupSave} />
                    </div>
                </Dialog>

                <Dialog
                        header="Add Stage"
                        visible={showStagepopup}
                        onHide={handleCancelStagePopup}
                        style={{ width: "35vw", maxWidth: "600px" }}
                        footer={
                          <div className="flex gap-2 justify-content-end">
                            <Button
                              label="Cancel"
                              icon="pi pi-times"
                              className="p-button-secondary"
                              onClick={handleCancelStagePopup}
                            />
                
                            <Button
                              label="Save"
                              icon="pi pi-check"
                              className="p-button-success"
                              onClick={stageSubmit(onSubmitStages)}
                            />
                          </div>
                        }
                      >
                        <form className="grid">  
                          <Col lg={12}>
                            <label className="block mb-2 mt-2">
                              Stage / Level <span className="text-red-500">*</span>
                            </label>
                            <InputText
                              className={`w-full ${StageErrors.statusName && "p-invalid"}`}
                              placeholder="Enter Stage / Level name"
                              {...StageRegister("statusName", {
                                required: "Stage  is required"
                              })}
                            />
                
                            {StageErrors.statusName && (
                              <small className="p-error">
                                {StageErrors.statusName.message}
                              </small>
                            )}
                          </Col>
                           <Col lg={12}>
                            <label htmlFor="city" className="mb-1 mt-4">
                             Company <span style={{ color: "red" }}>*</span>
                            </label>
                            <Dropdown
                              id="status"
                              value={selectedresponsiblePersonCompany}
                              onChange={(e) => {setSelectedresponsiblePersonCompany(e.value);getTeam(e.value);}}
                              options={compamyitem}
                              placeholder="Select Responsible Person"
                              className="w-full bgclr"
                              optionLabel="name"
                              optionValue="id"
                              filter
                            />
                          </Col>
                          <Col lg={12}>
                            <label htmlFor="city" className="mb-1 mt-4">
                              Responsible Person <span style={{ color: "red" }}>*</span>
                            </label>
                            <Dropdown
                              id="status"
                              value={selectedresponsiblePerson}
                              onChange={(e) => setSelectedresponsiblePerson(e.value)}
                              options={teamData}
                              placeholder="Select Responsible Person"
                              className="w-full bgclr"
                              optionLabel="name"
                              optionValue="id"
                              filter
                              loading={teamLoading}
                            />
                          </Col>
                          <Col lg={12}>
                            <label htmlFor="city" className="mb-1 mt-4">
                              Group 
                            </label>
                            <Dropdown
                              id="status"
                              value={selectedGroup}
                              onChange={(e) => setSelectedGroup(e.value)}
                              options={groupOptions}
                              placeholder="Select Group"
                              className="w-full bgclr"
                              optionLabel="group_name"
                              optionValue="id"
                              filter
                            />
                          </Col>
                        </form>
                      </Dialog>

            </div>
        </React.Fragment>
    );
};

export default ProjectEditForm;